/**
 * Hamburger Menu Controller for Type B Header
 * Manages header layout transition between collapsed (hamburger) and expanded (Type A style) states
 */

class HamburgerMenuController {
  constructor() {
    /** @type {HTMLElement | null} */
    this.header = document.querySelector('#header-component.header--type-b');
    /** @type {HTMLButtonElement | null} */
    this.hamburgerButton = document.querySelector('[data-hamburger-button]');
    this.isExpanded = false;
    /** @type {number | null} */
    this.collapseTimeout = null;

    if (this.header && this.hamburgerButton) {
      this.init();
    }
  }

  init() {
    // 햄버거 버튼 클릭 이벤트
    this.hamburgerButton?.addEventListener('click', () => this.expand());

    // 닫기 버튼 클릭 이벤트 (이벤트 위임 사용 - mega-menu 안의 버튼들)
    this.header?.addEventListener('click', (e) => {
      const target = e.target;
      if (target instanceof Element) {
        const closeButton = target.closest('[data-header-close]');
        if (closeButton) {
          e.stopPropagation();
          this.collapse();
        }
      }
    });

    // 확장된 헤더 영역에서 마우스가 벗어날 때 자동 축소
    const headerRowExpanded = this.header?.querySelector('[data-header-state="expanded"]');
    if (headerRowExpanded) {
      headerRowExpanded.addEventListener('mouseleave', () => {
        this.scheduleCollapse();
      });

      // 마우스가 다시 들어오면 축소 취소
      headerRowExpanded.addEventListener('mouseenter', () => {
        this.cancelCollapse();
      });
    }
  }

  /**
   * 축소를 예약 (디바운싱 사용)
   */
  scheduleCollapse() {
    // 기존 타임아웃 취소
    this.cancelCollapse();

    // 300ms 후 축소 (사용자가 실수로 벗어났을 경우 대응)
    this.collapseTimeout = setTimeout(() => {
      this.collapse();
    }, 300);
  }

  /**
   * 예약된 축소 취소
   */
  cancelCollapse() {
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = null;
    }
  }

  expand() {
    if (!this.header) return;

    this.isExpanded = true;
    this.header.setAttribute('data-menu-expanded', 'true');

    if (this.hamburgerButton) {
      this.hamburgerButton.setAttribute('aria-expanded', 'true');
    }
  }

  collapse() {
    // 기존 타임아웃 취소
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = null;
    }

    if (!this.header) return;

    // 1. 먼저 모든 header-menu의 메가메뉴 닫기 애니메이션 시작
    const headerMenus = this.header.querySelectorAll('header-menu');
    headerMenus.forEach((menu) => {
      // Type guard: 커스텀 엘리먼트의 메서드 존재 확인
      if ('forceDeactivate' in menu && typeof menu.forceDeactivate === 'function') {
        menu.forceDeactivate();
      }
    });

    // 2. 애니메이션 완료 후 헤더 상태 변경 (DEACTIVATE_DELAY = 350ms)
    const ANIMATION_DELAY = 350;

    setTimeout(() => {
      this.isExpanded = false;
      this.header?.setAttribute('data-menu-expanded', 'false');

      if (this.hamburgerButton) {
        this.hamburgerButton.setAttribute('aria-expanded', 'false');
      }

      // aria-expanded 초기화
      const expandedMenuItems = this.header?.querySelectorAll('.menu-list__link[aria-expanded="true"]');
      expandedMenuItems?.forEach((item) => {
        item.setAttribute('aria-expanded', 'false');
      });
    }, ANIMATION_DELAY);
  }
}

// DOM 로드 후 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HamburgerMenuController());
} else {
  new HamburgerMenuController();
}
